import MatchPage from "@/pages/Manager/Match";
export default function ScoutingMatchPage(props) {
	return <MatchPage {...props} scoutingContext />;
}
